import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import { RecoveryState } from "../../types/Recovery";
import { ChangeStringValues } from "../../types/Auth";

const initialState: RecoveryState = {
  email: "",
  sent: false,
};

export const recoverySlice = createSlice({
  name: "recovery",
  initialState,
  reducers: {
    changeStringField(state, action: PayloadAction<ChangeStringValues>) {
      const { field, value } = action.payload;
      state[field] = value;
    },
    sentEmail(state) {
      state.sent = true;
    },
    resetSent(state) {
      state.sent = false;
    },
  },
});

export const { sentEmail, resetSent, changeStringField } =
  recoverySlice.actions;

export default recoverySlice.reducer;
